import * as React from 'react'
import styled from '../../utils/styled'
import './Loaderbar.scss'
interface LoaderbarProps {
  title: string
  logo: string
}

const Loaderbar: React.SFC<LoaderbarProps> = ({ title, logo }) => (
  <div className="slider">
    <div className="line" />
    <div className="subline inc" />
    <div className="subline dec" />
  </div>
)
export default Loaderbar
